<template>
  <v-card class="elevation-1 mb-6 rounded-lg mt-0">
    <v-card-title class="pa-7">
      Přehled aktivit
      <v-spacer></v-spacer>
    </v-card-title>
    <v-card-text>
      <v-data-table
        :headers="userHeadersByRole"
        :items="activity.items"
        :options.sync="activity.options"
        :server-items-length="activity.serverItemsLength"
        :loading="activity.loading"
        :expanded.sync="activity.expanded"
        :single-expand="true"
        item-key="id"
        class="elevation-0"
        show-expand
      >
        <template v-slot:expanded-item="{ item }">
          <td colspan="7" style="background: #f5f5f5">
            <CustomerDaktelaActivityMetadata :item="item" />
          </td>
        </template>
        <template v-slot:item.channel="{ item }">
          <DaktelaActivityChannel :channel="item.channel" />
        </template>
        <template v-slot:item.direction="{ item }">
          <DaktelaActivityDirection :direction="item.direction" />
        </template>
        <template v-slot:item.status="{ item }">
          <DaktelaActivityStatus :status="item.status" />
        </template>
        <template v-slot:item.createdAt="{ item }">
          <DateTime :single-line="false" :datetime="item.createdAt" />
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import DateTime from '@/components/DateTime'
import DaktelaActivityStatus from './DaktelaActivityStatus.vue'
import CustomerDaktelaActivityMetadata from './CustomerDaktelaActivityMetadata.vue'
import DaktelaActivityDirection from './DaktelaActivityDirection.vue'
import DaktelaActivityChannel from './DaktelaActivityChannel.vue'

export default {
  name: 'CustomerDaktelaActivities',
  components: {
    DaktelaActivityChannel,
    DaktelaActivityDirection,
    CustomerDaktelaActivityMetadata,
    DaktelaActivityStatus,
    DateTime,
  },
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      activity: {
        headers: [
          {
            text: 'Datum',
            value: 'createdAt',
            roles: ['ROLE_ADMIN'],
          },
          {
            text: 'Kanál',
            value: 'channel',
            roles: ['ROLE_ADMIN'],
          },
          {
            text: 'Fronta',
            value: 'queue',
            roles: ['ROLE_ADMIN'],
          },
          {
            text: 'Směr',
            value: 'direction',
            roles: ['ROLE_ADMIN'],
          },
          {
            text: 'Status',
            value: 'status',
            roles: ['ROLE_ADMIN'],
          },
          {
            text: 'Přiřazeno',
            value: 'externalUser',
            roles: ['ROLE_ADMIN'],
          },
          { text: '', value: 'data-table-expand', roles: ['ROLE_ADMIN'] },
        ],
        items: [],
        expanded: [],
        options: {
          page: 1,
          itemsPerPage: 10,
          sortBy: ['createdAt'],
          sortDesc: [true],
        },
        loading: false,
        serverItemsLength: 0,
      },
      activityFooter: {
        totalElements: 0,
        selectedData: {
          params: {},
          items: [],
        },
      },
      cancel: null,
    }
  },
  computed: {
    ...mapState({
      authorities: (state) => state.auth.user.authorities,
    }),
    userHeadersByRole() {
      return this.activity.headers.filter((e) => e.roles.some((e) => this.authorities.includes(e)))
    },
  },
  watch: {
    'activity.options': {
      handler() {
        this.loadActivities()
      },
    },
    '$route.query': {
      handler() {
        this.loadActivities()
      },
    },
  },
  methods: {
    ...mapActions({
      searchDaktelaActivities: 'daktela/searchDaktelaActivities',
    }),
    loadActivities() {
      this.activity.loading = true
      let query = {}
      const searchParams = {
        filterParams: query,
        options: this.activity.options,
      }
      this.searchDaktelaActivities({ id: this.id, params: searchParams })
        .then((response) => {
          this.activityFooter.totalElements = response.data.totalElements
          this.activity.items = response.data.items
          this.activity.serverItemsLength = response.data.totalElements
          this.cancel = null
        })
        .finally(() => {
          this.activity.loading = false
        })
    },
  },
}
</script>

<style>
.v-data-table__expanded.v-data-table__expanded__content {
  box-shadow: inset 0px -2px 0px -1px rgba(0, 0, 0, 0.4) !important;
}
</style>
